import React from 'react'

const Button = ({handleChangeDisplay, handleOperator, handleEquals , handleClear, disabled}) => {    

    return(
    <div className="button-wrapper">
        <div className="row">
                <button className="clear" onClick={() =>handleClear()} >C</button>
                <button disabled = {disabled} onClick = {() => handleOperator (' % ')}>Mod</button>
                <button disabled = {disabled} onClick = {() => handleOperator (' / ')}>/</button>
        </div>
        <div className="row">
            <button onClick={() => handleChangeDisplay("7")} >7</button>
            <button onClick={() => handleChangeDisplay("8")}>8</button>
            <button onClick={() => handleChangeDisplay("9")}>9</button>
            <button disabled = {disabled} onClick ={() => handleOperator (' * ')}>*</button>
        </div>
        <div className="row">
            <button onClick={() => handleChangeDisplay("4")}>4</button>
            <button onClick={() => handleChangeDisplay("5")}>5</button>
            <button onClick={() => handleChangeDisplay("6")}>6</button>
            <button disabled = {disabled} onClick={() => handleOperator(" + ")}>+</button>
        </div>
        <div className="row">
            <button onClick={() => handleChangeDisplay("1")}>1</button>
            <button onClick={() => handleChangeDisplay("2")}>2</button>
            <button onClick={() => handleChangeDisplay("3")}>3</button>
            <button disabled = {disabled} onClick={() => handleOperator(" - ")}>-</button>
        </div>
        <div className="row">
            <button onClick={() => handleChangeDisplay(".")}>.</button>
            <button onClick={() => handleChangeDisplay("0")}>0</button>
            <button className="equals" onClick={() => handleEquals()}>=</button>
        </div>
      </div>
    )

}

export default Button